const currencyExpensesParams = value => ({
    currency: value,
    symbolCurrency: 'EUR',
    periodicy: false,
    isFormated: false,
    classes: false,
    withDecimals: true
});

module.exports = {
    currencyExpensesParams
}
